module.exports = __webpack_public_path__ + "img/arrow.d55e7318.png";